import React, { Component } from 'react'

import { translation } from '../../../utils/helpers'

import './labelWrapper.scss'

// Components
import HelpIcon from '../helpIcon'

/**
 * Implements a component to wrap child components and displaying a label, hint and error-text around it.
 * - Help text is shown in a small popup when user clicks the (?) icon.
 * - Hint text is always shown unless error text is specified.
 * - Error text is always shown if specified.
 */
class LabelWrapper extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showHint: false,
      showHelp: false
    }
    this.toggleShowHint = this.toggleShowHint.bind(this)
  }

  toggleShowHint () {
    this.setState({showHint: !this.state.showHint})
  }

  renderTop () {
    let hasLabel = this.props.labelText !== null
    let hasHelp = this.props.helpText !== null

    if (!hasLabel) return null
    let labelText = this.props.labelText
    let helpText = this.props.helpText
    if (typeof labelText === 'number') labelText = translation(labelText)
    if (typeof helpText === 'number') helpText = translation(helpText)
    return (
      <div className='top'>
        <label htmlFor={this.props.for}>{labelText}</label>
        {hasHelp && <HelpIcon helpText={helpText} />}
      </div>
    )
  }

  renderBottom () {
    if (this.props.labelText === null || (this.props.errorText === null && this.props.hintText === null)) return null

    // Show hint or error text
    let text = this.props.hintText !== null ? this.props.hintText : ''
    let isError = false
    if (this.props.errorText !== null) {
      text = this.props.errorText
      isError = true
    }
    let labelCss = 'pg-ml-2 ' + (isError ? 'error' : 'hint')
    return (
      <div className='bottom'>
        <span className={labelCss}>{text}</span>
      </div>
    )
  }

  getSpacingClass () {
    let spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing
    if (spacing < 1) return ''
    return ' pg-mb-' + spacing
  }

  render () {
    let propClassNames = this.props.className ? ` ${this.props.className}` : ''
    return (
      <div className={'element-label-wrapper' + propClassNames + this.getSpacingClass()}>
        {this.renderTop()}
        <div className='content'>
          {this.props.children}
        </div>
        {!this.props.simple && this.renderBottom()}
      </div>
    )
  }
}

LabelWrapper.defaultProps = {
  labelText: 'Tekst mangler!',
  for: null,
  hintText: null,
  helpText: null,
  errorText: null,
  simple: false,
  spacing: 2,
  className: null
}

export default LabelWrapper



// WEBPACK FOOTER //
// ./src/app/shared/elements/labelWrapper/index.js